// Age and footwear rules shared by the browser (src/config/categories.js) and
// the server (api/_lib/ensembleRules.js). Plain CommonJS; no imports.

// Dancers this age and over in a youth division are expected on pointe.
const POINTE_EXPECTED_FROM_AGE = 12;
const SOFT_SHOE_WARNING =
  'Dancers 12 and over are expected to dance on pointe in this division. Judges will deduct technique points for soft shoes.';
// Pointe for young dancers, as YAGP: not allowed under 11, strongly
// discouraged at 11.
const POINTE_ALLOWED_FROM_AGE = 11;
const POINTE_DISCOURAGED_BELOW_AGE = 12;
const POINTE_TOO_YOUNG_WARNING = 'Dancers 10 and under can\'t dance on pointe. Please choose soft shoes.';
const POINTE_DISCOURAGED_WARNING = 'Pointe is strongly discouraged at age 11. We recommend soft shoes.';

/**
 * Age as of Jan 1 of the competition year (standard dance competition cutoff).
 * Reads 'YYYY-MM-DD' as calendar parts: new Date('2009-01-02') is UTC
 * midnight, which is Jan 1 in Canadian time zones and would make a dancer born
 * Jan 2 a year older.
 */
function ageAsOf(dateOfBirth, year) {
  const [birthYear, birthMonth, birthDay] = String(dateOfBirth).slice(0, 10).split('-').map(Number);
  // Jan 1 cutoff: anyone born after Jan 1 hasn't had their birthday yet.
  const hadBirthday = birthMonth === 1 && birthDay === 1;
  return year - birthYear - (hadBirthday ? 0 : 1);
}

/**
 * The footwear warning for one dancer's entry, or null: soft shoes at 12+, or
 * pointe under 12. Youth entries only: adults may dance in either footwear.
 * Never blocks the entry.
 */
function softShoeWarning({ dateOfBirth, footwear, isAdultEntry, year }) {
  if (!footwear || isAdultEntry || !dateOfBirth) return null;
  const age = ageAsOf(dateOfBirth, year);
  if (footwear === 'soft') return age >= POINTE_EXPECTED_FROM_AGE ? SOFT_SHOE_WARNING : null;
  if (age < POINTE_ALLOWED_FROM_AGE) return POINTE_TOO_YOUNG_WARNING;
  if (age < POINTE_DISCOURAGED_BELOW_AGE) return POINTE_DISCOURAGED_WARNING;
  return null;
}

module.exports = {
  POINTE_EXPECTED_FROM_AGE, POINTE_ALLOWED_FROM_AGE, POINTE_DISCOURAGED_BELOW_AGE, SOFT_SHOE_WARNING,
  ageAsOf, softShoeWarning,
};
